<div
  class="
    empty-state
    bg-color-ebony-a03
    l_flex
    m-l_flex
    l_flex-middle l_flex-justify-center
  "
>
  <ng-content *ngIf="ownerIsViewing && !isReadOnly"></ng-content>
  <div
    *ngIf="!ownerIsViewing || isReadOnly"
    class="color-ebony-a61 font-medium center-text"
  >
    <div>
      <df-icon icon="info"></df-icon>
    </div>
    <div class="guts-m-t-half">
      {{ 'dgProfileOverview_OverviewNotProvidedTitle' | translate }}
    </div>
  </div>
</div>
